import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Self {
    constructor() {
        // Home
        this.sliderPlat();
    }

    sliderPlat() {
        const sliders = document.querySelectorAll('section.content .food-wrapper .food-item .description .images');
        if (sliders.length > 0) {
            let cAutoplay = false;
            let cLoop = false;

            if (document.body.classList.contains('post-type-archive-menus')) {
                cAutoplay = true;
                cLoop = true;
            }

            sliders.forEach((slider) => {
                tns({
                    container: slider,
                    slideBy: 'page',
                    items: 1,
                    autoplay: cAutoplay,
                    loop: cLoop,
                    navPosition: 'bottom',
                    controlsText: [
                        '',
                        '',
                    ]
                });
            });
        }
    }
}